import gql from 'graphql-tag';

export const searchPatients = gql`query searchPatients($searchString: String!)
  {
    patientUsers(
      conditions: { function: search, value: $searchString },
      limit: 10
    ) {
      edges {
        node {
          id
          subjectId
          patient {
            birthdate
            patientId
          }
        }
      }
    }
  }`;

export const getAllPatients = gql`query getAllPatients(
      $searchString: String!,
      $limit: Int,
      $offset: Int,
      $orders: [RelayUserOrder!],
    ) {
      patientUsers(
        conditions: {function: search, parameters: [$searchString]},
        limit: $limit
        offset: $offset
        meta: {
          count: true
        }
        orders: $orders
      ){
        edges {
          node {
            id
            subjectId
            enrollmentDate
            patient {
              gender
              birthdate
              patientId
            }
          }
        }
        count
      }
    }`;


